import { render, staticRenderFns } from "./feeNotice.vue?vue&type=template&id=b28e63de&scoped=true&"
import script from "./feeNotice.vue?vue&type=script&lang=js&"
export * from "./feeNotice.vue?vue&type=script&lang=js&"
import style0 from "./feeNotice.vue?vue&type=style&index=0&id=b28e63de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28e63de",
  null
  
)

export default component.exports